export default {
    contactUs: 'Lépjen kapcsolatba velünk',
    contact: 'Kapcsolat',
    blogTitle: 'Építjük a mosolygás jövőjét',
    blogDescription:
        'Olyan termékeket fejlesztünk, amelyek azon a meggyőződésen alapulnak, hogy a fogfehérítés hatékony és biztonságos lehet.',
    blogButton: 'Összes megtekintése',
    allAboutHelloCoco: 'Minden a hello coco-ról',
    aboutUs: 'Rólunk',
    reviews: 'Értékelések',
    reviewsLink: '/recenze/',
    cocoEmail: 'kapcsolat@hellococo.hu',
    termsAndConditions: 'Általános szerződési feltételek',
    termsAndConditionsLink: '/szerzodesi-feltetelek/',
    privacyPolicy: 'Adatvédelmi irányelvek',
    privacyPolicyLink: '/szemelyes-adatok-vedelme/',
    purchase: 'Vásárlás',

    emptyCartText: 'A kosár várja első felfedezéseit - nézd meg kínálatunkat!',
    startShopping: 'Vásárlás kezdése',

    orderSummary: 'Rendelés összegzése',
    shippingAndPayment: 'Szállítás és fizetés',
    discountCoupon: 'Kedvezmény kupon',
    applyDiscount: 'Alkalmazás',
    giftsHeading: 'Válassz ingyenes ajándékot',

    orderInfo: 'Az Ön adatai',
    orderNumber: 'Rendelésszám',

    'header.others': 'Egyéb',
    'header.categories': 'Kategóriák',
    'header.followUs': 'Kövess minket',

    'emptyCart.title': 'A kosara üres',
    'emptyCart.backToShop': 'Vissza a boltba',

    show_all: 'Összes megtekintése',

    aboutUsLink: '/rolunk/',
    contactUsLink: '/kerdesem-van/',
}
